// import logo from './logo.svg';
import '../App.css';
import Home from '../pages/home';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Routes,Route,Link,Navigate } from 'react-router-dom';
import Login from '../pages/login';
import Create from '../pages/create';

function Guest() {
  
  return (
    <div>
    <nav className='navbar navbar-expand navbar-dark bg-dark'>
      <div className='navbar-nav mr-auto'>
      {/* <li className='nav-item'>
        <Link to='/' className='nav-link'>Home</Link>
      </li> */}
      
      <li className='nav-item'>
        <Link to='/login' className='nav-link'>Login</Link>
      </li>
      <li className='nav-item'>
        <Link to='/create' className='nav-link'>Register</Link>
      </li>
      
      {/* <li className='nav-item'>
        <Link to='/register' className='nav-link'>Register</Link>
      </li> */}
      
      </div>
    </nav>
    <div className='container'>
    <Routes>
    <Route path='/' element={<Home />} />
    <Route path='/login' element={<Login />} />
    <Route path='/create' element={<Create />} />
    <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
    </div>
    </div>
  );
}

export default Guest;
